import React, {useEffect, useMemo, useRef} from 'react'
import {useTranslation} from 'react-i18next'

import {RadiumExternalLink} from 'components/radium'

interface HelpDeskLinkProps extends Omit<React.HTMLProps<HTMLAnchorElement>, 'ref' | 'href'> {
  children: string
  href?: string
}

interface HelpDeskLinkBasicProps {
  href: string
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void
}

const helpDeskProductSource = `${config.productName.toLowerCase()}-${config.countryId}`

export const useHelpDeskLinkProps = (props?: Partial<HelpDeskLinkBasicProps>):
HelpDeskLinkBasicProps => {
  const {onClick} = props || {}
  const {t: translate} = useTranslation('components')
  const timeout = useRef<number|undefined>(undefined)
  useEffect((): (() => void) => (): void => window.clearTimeout(timeout.current), [])
  const finalHref = translate(config.helpRequestUrl, {
    productSource: encodeURIComponent(helpDeskProductSource),
    ticketId: '',
  })
  return {href: finalHref, onClick}
}


const HelpDeskLink: React.FC<HelpDeskLinkProps> =
({onClick, style, ...props}): React.ReactElement => {
  const {href: finalHref, onClick: finalOnClick} = useHelpDeskLinkProps({onClick})
  const finalStyle = useMemo(() => ({
    color: 'inherit',
    textDecoration: 'none',
    ...style,
  }), [style])
  // eslint-disable-next-line jsx-a11y/anchor-has-content
  return <RadiumExternalLink
    {...props} href={finalHref} onClick={finalOnClick} style={finalStyle} />
}


export default React.memo(HelpDeskLink)
